var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.76367H3C2.73478 1.76367 2.48043 1.86903 2.29289 2.05657C2.10536 2.2441 2 2.49846 2 2.76367V9.76367C2 10.0289 2.10536 10.2832 2.29289 10.4708C2.48043 10.6583 2.73478 10.7637 3 10.7637H10C10.2652 10.7637 10.5196 10.6583 10.7071 10.4708C10.8946 10.2832 11 10.0289 11 9.76367V6.26367",
    stroke: "#99A1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68755 1.57629C9.88646 1.37737 10.1562 1.26563 10.4375 1.26562C10.7189 1.26562 10.9886 1.37737 11.1875 1.57629C11.3865 1.7752 11.4982 2.04498 11.4982 2.32629C11.4982 2.60759 11.3865 2.87737 11.1875 3.07629L6.68105 7.58329C6.56232 7.70191 6.41565 7.78874 6.25455 7.83578L4.81805 8.25578C4.77502 8.26833 4.72942 8.26909 4.686 8.25796C4.64259 8.24684 4.60296 8.22425 4.57127 8.19256C4.53958 8.16087 4.51699 8.12124 4.50587 8.07783C4.49475 8.03442 4.4955 7.98881 4.50805 7.94579L4.92805 6.50928C4.97531 6.34831 5.06231 6.20181 5.18105 6.08329L9.68755 1.57629Z",
    stroke: "#99A1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d4d6e38f2942b14b2aa5b869d3016608.svg";
export { ForwardRef as ReactComponent };